export class AppData
{
    public static API_URL: string;
    public static API_KEY: string;
    public static localStorageToken: string;
    public static PERMISOSMENU: any;
    public static DIAGRAM_DATA: any;
    public static DIAGRAM_URL: any;
    public static tiempo_refresh_Tareas: any;
    public static ALLOWED_FILE_TYPES: any;
    public static MAX_FILE_SIZE: any;
    public static tiempo_refresh_Notificaciones: any;
    public static MAX_LENGTH_FORM: any;
    public static ViewSSOLoginButton: boolean;
    public static ENABLE_CONECTORES: boolean;
    public static ClientIdSSO: string;
    public static AuthoritySSO: string;
    public static ScopeSSO: string;
    public static RedirectUriSSO: string;
    public static ENABLE_AGENTE_REPETITIVAS: boolean;
    public static CHUNKED_UPLOAD_THRESHOLD_MB: number;
    public static CHUNK_SIZE_MB: number;
    public static ENABLE_CHUNKED_UPLOAD: boolean;
    public static ENABLE_AGENTE_CUELLOS_BOTELLA: boolean;
    public static MODO_VISUALIZACION_ANALISIS_IA: string;
}

